import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { fadeIn2XFastEnter, fadeOut2XFastLeave } from '@pct-ng/animation';

@Component({
  selector: 'pct-common-progress-bar',
  imports: [MatProgressBar],
  templateUrl: './progress-bar.component.html',
  animations: [fadeIn2XFastEnter, fadeOut2XFastLeave],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block w-full',
    '[class.!absolute]': 'absolute()',
    '[class.bottom-0]': 'absolute()',
    '[class.left-0]': 'absolute()',
    '[@fadeIn2XFastEnter]': '',
    '[@fadeOut2XFastLeave]': '',
  },
})
export class ProgressBarComponent {
  readonly absolute = input(true);
}
